import React, {useEffect, useState} from "react";
import {useTheme} from "../contexts/theme";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import '../index.css'
import axiosInstance, {setupAxiosInterceptors} from "../queries/axiosInstance";
import {Header} from "../components/HeaderComponent/Header";
import {Footer} from "../components/FooterComponent/Footer"
import DashboardTable from "../components/DashboardContent/DashboardTable";
import {formatDuration} from "../utils/utils";
import PageContainer from "../components/CommonComponents/PageContainer/PageContainer";
import {LoadError} from "../types/generic";
import ErrorSnackBar from "../components/CommonComponents/ErrorSnackBar/ErrorSnackBar";

type rowsMatch = {
    date: string,
    competition: string,
    matchName: string,
    matchDate: string,
    matchLang: string,
    status: string,
    duration: string,
    clips: number,
    amount: number
}

const Dashboard = () => {
    const theme = useTheme();
    const [rowsData, setRowsData] = useState<rowsMatch[]>([]);
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState<LoadError>({error: false, message: ''});

    const fetchRows = async () => {
        try {
            if(localStorage.getItem('token')) {
                const response = await axiosInstance.get('/billing/userData');
                return response.data;
            }
        } catch (error: any) {
            console.error("Failed to fetch data:", error);
            if (error.response && error.response.status !== 403) {
                setLoadError({ error: true, message: 'Unable to display requested data' });
            }
            return [];
        }
    }

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            const data = await fetchRows();
            // for (let i = 0; i < data.length; i++) {
            //     data[i].duration = formatDuration(data[i].duration);
            // }
            setRowsData(data);
            setLoading(false);
        };
        getData().then(r => {});
    }, []);


    return (
        <PageContainer>
            <Box
                style={{
                    width: "100%",
                    height: "100%",
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    backgroundColor: theme.palette.blue
                }}
            >
            <Grid container direction="column"  style={{ height: '100%' }}>


                {/* Main Content */}
                <Grid item xs={12} sm={10} md={10} lg={8} sx={{
                    padding: theme.spacing.none,
                    height: '100%',
                    flex: 1,
                    width: '100%',
                    color: "white",
                    paddingLeft: {xs: theme.spacing.none , sm:theme.spacing.sm, md: theme.spacing.md, lg: theme.spacing.lg, xl: theme.spacing.xl },
                    paddingRight: {xs: theme.spacing.none , sm:theme.spacing.sm, md: theme.spacing.md, lg: theme.spacing.lg, xl: theme.spacing.xl },
                    backgroundColor: theme.palette.blue,
                }}>
                <DashboardTable rowsData={rowsData} setrowsData={setRowsData} loading={loading} />
                    <ErrorSnackBar autoHideDuration={5000} open={loadError.error} setClose={() => setLoadError({message:'', error: false})} errorMessage={loadError.message}/>
                </Grid>


            </Grid>
        </Box>
        </PageContainer>
    );
}

export default Dashboard;
